/**
 * AuctionResultSubcribe
 * 
 * @Author: Focci
 * @Date: 2025-01-22 09:37:12
 * @Last Modified by: Focci
 * @Last Modified time: 2025-01-22 09:37:12
 */

'use client'

import SVGSubcribe from '@img/add-subcribe.svg'
import useDialog from '@hook/useDialog'
import CircularProgress from '@mui/material/CircularProgress'
import useLazyComponent from '@hook/useLazyComponent'
import useLogin from '@hook/useLogin'
import { useCallback, useEffect } from 'react'
import { Button } from '@comp/material'
import { useTranslations } from 'next-intl'

function AuctionResultSubcribeButton(props) {
  const tt = useTranslations('track')

  return (
    <Button {...props}>
      <SVGSubcribe width=".8rem" height=".8rem" />
      <span className="ml-1">{tt('subcribe')}</span>
    </Button>
  )
}

function AuctionResultSubcribeBody({ ...props }) {
  const { Wedget: MailConsultingAgency, getWedget, ready } = useLazyComponent()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { getWedget(() => import('./AuctionResultSubcribeForm')) }, [])

  if(!ready) {
    return (
      <div className="flex items-center justify-center h-40">
        <CircularProgress />
      </div>
    )
  }

  return (
    <MailConsultingAgency {...props} />
  )
}

export default function AuctionResultSubcribe({ districtId }) {
  const th = useTranslations('house')
  const { isLogin, openSigninDialog } = useLogin()
  const { openDialog, closeDialog, Dialog } = useDialog()

  const handleClick = useCallback(() => {
    !isLogin ? openSigninDialog() : openDialog()
  }, [isLogin, openDialog, openSigninDialog])

  return (
    <>
      <AuctionResultSubcribeButton onClick={handleClick} />
      <Dialog title={th('subcribeAuction')}>
        <AuctionResultSubcribeBody districtId={districtId} onSuccess={closeDialog} />
      </Dialog>
    </>
  )
}
